import { ApplicationRecord } from "../types/system";

export const eventRows = [
  { title: "জাতীয় পর্যটন আলোকচিত্র প্রতিযোগিতা ২০২৬", code: "NTPC-2026", type: "ছবি প্রতিযোগিতা", deadline: "১৫ অক্টোবর ২০২৬", applications: 348, status: "আবেদন চলছে" },
  { title: "বাংলাদেশ ট্যুরিজম অ্যাওয়ার্ড ২০২৬", code: "BTA-2026", type: "অ্যাওয়ার্ড", deadline: "৩০ অক্টোবর ২০২৬", applications: 126, status: "আবেদন চলছে" },
  { title: "Taste of Bangladesh ২০২৬", code: "TOB-2026", type: "ফেস্টিভ্যাল", deadline: "১২ অক্টোবর ২০২৬", applications: 218, status: "যাচাই চলছে" },
  { title: "Harmony Festival ২০২৬", code: "HF-2026", type: "ফেস্টিভ্যাল", deadline: "১৮ অক্টোবর ২০২৬", applications: 174, status: "আবেদন চলছে" },
  { title: "ITB Berlin ২০২৭-এ বাংলাদেশ প্যাভিলিয়নে অংশগ্রহণ", code: "ITB-BERLIN-2027", type: "আন্তর্জাতিক পর্যটন মেলা", deadline: "২০ নভেম্বর ২০২৬", applications: 64, status: "আবেদন চলছে" },
  { title: "ঢাকা আন্তর্জাতিক পর্যটন মেলা ২০২৬", code: "DITF-2026", type: "দেশীয় পর্যটন মেলা", deadline: "২৮ সেপ্টেম্বর ২০২৬", applications: 92, status: "মূল্যায়ন চলছে" },
];

export const initialApplications: ApplicationRecord[] = [
  { id: "BTB-NTPC-2026-00124", applicant: "সাদিয়া রহমান", district: "ঢাকা", category: "প্রকৃতি", submitted: "০৮ অক্টোবর ২০২৬", stage: "জুরি মূল্যায়ন", score: 86.5, status: "মূল্যায়নাধীন" },
  { id: "BTB-NTPC-2026-00125", applicant: "তানভীর হাসান", district: "চট্টগ্রাম", category: "ঐতিহ্য", submitted: "০৮ অক্টোবর ২০২৬", stage: "শর্টলিস্ট", status: "শর্টলিস্টেড" },
  { id: "BTB-NTPC-2026-00126", applicant: "নুসরাত জাহান", district: "সিলেট", category: "মানুষ ও সংস্কৃতি", submitted: "০৯ অক্টোবর ২০২৬", stage: "প্রাথমিক যাচাই", status: "যাচাই অপেক্ষমাণ" },
  { id: "BTB-BTA-2026-00087", applicant: "গ্রিন ভ্যালি ইকো রিসোর্ট", district: "মৌলভীবাজার", category: "টেকসই পর্যটন উদ্যোগ", submitted: "০৬ অক্টোবর ২০২৬", stage: "চূড়ান্ত মূল্যায়ন", score: 91.2, status: "মূল্যায়নাধীন" },
];

export const workflowSteps = ["আবেদন জমা", "প্রাথমিক যাচাই", "ডকুমেন্ট যাচাই", "শর্টলিস্ট", "জুরি মূল্যায়ন", "চূড়ান্ত অনুমোদন", "ফলাফল প্রকাশ", "সার্টিফিকেট ইস্যু"];

export const navGroups = [
  { label: "ড্যাশবোর্ড", view: "dashboard" },
  { label: "ইভেন্ট ও প্রোগ্রাম", view: "events" },
  { label: "আবেদনসমূহ", view: "applications" },
  { label: "প্রতিযোগিতা ও অ্যাওয়ার্ড", view: "event-dashboard" },
  { label: "জুরি ব্যবস্থাপনা", view: "jury" },
  { label: "ওয়ার্কফ্লো", view: "workflow" },
  { label: "ফলাফল", view: "results" },
  { label: "সার্টিফিকেট", view: "certificate" },
  { label: "আর্কাইভ", view: "archive" },
  { label: "রিপোর্ট", view: "reports" },
  { label: "নোটিফিকেশন", view: "notifications" },
  { label: "ব্যবহারকারী ও ভূমিকা", view: "roles" },
  { label: "অডিট লগ", view: "audit" },
] as const;
